import lgjLayout from '@/layouts/lgj'

export default [
  {
    name: 'lgj',
    path: '/',
    redirect: '/download',
    component: lgjLayout,
    children: [
      {
        name: 'lgjDownload',
        path: '/download',
        component: () => import('_lgj/download'),
        meta: {
          title: '乐管家APP'
        }
      }
    ]
  }
]
